import React from 'react';

const ClaimMemorialBanner = ({ onClaim, claiming, error }) => (
  <div className="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-brand-light border border-brand-dark rounded-2xl px-5 py-4">
    <div>
      <p className="text-xs font-black uppercase tracking-widest text-accent-navy">Is this your memorial?</p>
      <p className="text-[11px] text-text-muted">
        Claim it to unlock owner tools. Only one account can own a memorial.
      </p>
      {error && <p className="text-[11px] text-red-500 mt-1">{error}</p>}
    </div>
    <button
      type="button"
      onClick={onClaim}
      disabled={claiming}
      className="px-5 py-2.5 bg-accent-navy text-white rounded-xl text-[10px] font-black uppercase tracking-widest disabled:opacity-60"
    >
      {claiming ? 'Claiming…' : 'Claim ownership'}
    </button>
  </div>
);

export default ClaimMemorialBanner;